import {KeepNutshellPill} from 'shells/acorn-pill/svg/keep-nutshell';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import {ExpiredTrialActionCard} from '../expired-trial-modal/expired-trial-action-card';

import styles from './expired-page.module.css';

export function ExpiredPageContent() {
    return (
        <Stack spacing={32} alignItems='start'>
            <Body size='large' isBold={true} color='orange-attention'>
                Your trial has ended
            </Body>
            <h1 className={styles['headline']}>We don’t like goodbyes</h1>
            <Body>
                Your trial may be over, but we’re not ready to say goodbye. Choose a plan and keep
                Nutshell in your corner.
            </Body>
            <ExpiredTrialActionCard
                pill={KeepNutshellPill}
                body='Please ask an administrator to choose a plan to continue using Nutshell.'
                cta={{
                    type: 'action',
                    label: 'Explore plans',
                    onClick: () => {
                        window.open(
                            'https://www.nutshell.com/pricing/',
                            '_blank',
                            'noopener,noreferrer'
                        );
                    },
                }}
            />
            <Body>
                Need a little more time?{' '}
                <Link href='https://support.nutshell.com/' variant='primary' newTab={true}>
                    Contact Nutshell support
                </Link>{' '}
                about extending your trial or additional billing options.
            </Body>
        </Stack>
    );
}
